import axios from 'axios';

import { AllergenLogic } from 'enums/allergenLogic';
import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(
	searchTerm: string,
	showOnlyDeleted: boolean
): Promise<Optional<ResponseAllergen[]>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Allergen/StartingWith`;
	const params: Parameter = {
		SearchTerm: searchTerm,
		ShowOnlyDeleted: showOnlyDeleted,
	};
	return axios
		.get(url, {
			params: params,
		})
		.toOptionalMapped((x) => x.data.allergens);
}

interface Parameter {
	SearchTerm: string;
	ShowOnlyDeleted: boolean;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	allergens: ResponseAllergen[];
};

export type ResponseAllergen = {
	id: string;
	name: string;
	display: boolean;
	iconSvgUrl: string;
	logic: AllergenLogic;
};
